export default {
  orZn: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500024C","或者，") /* "或者，" */,
  contentZn: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500024D","同时满足如下条件的订单，订单提交后系统自动确认") /* "同时满足如下条件的订单，订单提交后系统自动确认" */
};
